import { useState } from 'react';
import { Theme, useMediaQuery } from '@mui/material';

export const useCardTableLayout = () => {
  const automaticTableLayout = useMediaQuery<Theme>((theme) => theme.breakpoints.up(1800));
  const [preferredTableLayout, setPreferredTableLayout] = useState<boolean>();

  return {
    withTableLayout: preferredTableLayout ?? automaticTableLayout,
    setTableLayout: setPreferredTableLayout,
  };
};
